import { FC, Fragment } from "react";
import React from "react";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { NumberInput } from "../core/NumberField";
import { useStyles } from "../../useStyles";
import { Switch } from "../core/Switch";
import { ChargingDeviceIcon } from "../core/icons/Icons";
import { BoxedInputWithIconAndOptionalSwitch } from "../core/BoxedInputWithIconAndOptionalSwitch";
import { InputLabel } from "@material-ui/core";

export const AdjustableLoadElectricLoaderForm: FC = () => {
    const classes = useStyles();
    const { values, getFieldProps, setValues } = useFormModel<
        ChangeNames.ADJUSTABLE_LOAD_ELECTRIC_LOADER
    >();
    return (
        <Fragment>
            <BoxedInputWithIconAndOptionalSwitch
                icon={<ChargingDeviceIcon />}
                content={
                    <Fragment>
                        <p className={classes.label} style={{ marginBottom: 8 }}>
                            Ladeeinrichtung
                        </p>
                        <p className={classes.p} style={{ marginTop: 0, marginBottom: 24 }}>
                            Sofern bereits heute eine Ladeeinrichtung an der Bauadresse existiert,
                            ist diese hier zu erfassen.
                        </p>
                        <p className={classes.p} style={{ marginTop: 0, marginBottom: 24 }}>
                            Hinweis: Angaben zur neuen Ladeeinrichtung machen Sie bitte auf der
                            nächsten Seite.
                        </p>
                    </Fragment>
                }
                useSwitch={
                    <Switch
                        checked={values.adjustableLoadElectricLoader.value.installed}
                        {...getFieldProps("adjustableLoadElectricLoader.value.installed")}
                        onChange={(e, checked) =>
                            setValues(values => {
                                values.adjustableLoadElectricLoader.value.installed = checked;
                                values.adjustableLoadElectricLoader.value.demand.amount = checked
                                    ? 0
                                    : null;
                            })
                        }
                    />
                }
                detailCondition={values.adjustableLoadElectricLoader.value.installed}
                detail={
                    <Fragment>
                        <InputLabel className={classes.labledTextfieldLabel}>
                            Summe der Leistung
                        </InputLabel>
                        <NumberInput
                            className={classes.textField}
                            decimalScale={values.adjustableLoadElectricLoader.value.demand.precision}
                            allowLeadingZeros={false}
                            allowNegative={false}
                            thousandSeparator="."
                            decimalSeparator=","
                            adornment={values.adjustableLoadElectricLoader.value.demand.unit}
                            value={values.adjustableLoadElectricLoader.value.demand.amount || ""}
                            placeholder="0"
                            onValueChange={v =>
                                setValues(values => {
                                    values.adjustableLoadElectricLoader.value.demand.amount =
                                        v.floatValue || null;
                                })
                            }
                            error={values.adjustableLoadElectricLoader.error != null}
                        />
                    </Fragment>
                }
            />
        </Fragment>
    );
};
